/* Built In Imports */

/* External Imports */
import { Box, Flex, Text } from '@chakra-ui/react';

/* Internal Imports */
/* Components */
import LazyLoadImageComponent from '@app-ps/Components/Ui/LazyLoadImageComponent';
import config from '@config';
/* Styles */
/* Services */

/**
 *
 * @param {Object} sectionContent
 * @param {string} lang - Language of Page
 * @returns
 */
const SamskritiQuote = ({ sectionContent, lang, region }) => {
  const { quote, decoration } = sectionContent;

  return (
    <Box w="100%" h="100%" mt={{ base: '-1rem', md: '0' }}>
      <Box
        w="100%"
        backgroundImage={{
          base: `${config.imgPath}/d/46272/1725096876-ps-quote-bg-mobile.png`,
          lg: `${config.imgPath}/d/46272/1724136999-group-1171277747.png`,
        }}
        backgroundRepeat="no-repeat"
        // backgroundSize={{
        //   base: '100% 100%',
        //   sm: 'cover',
        //   md: '100% 100%',
        //   lg: 'cover',
        //   xl: '100% 100%',
        // }}
        backgroundSize="cover"
        bgPos={{ base: 'top', lg: 'center' }}
        minH={{ base: '660px', '2xl': '774px' }}
        objectFit="cover"
      >
        <Flex
          display="flex"
          w="100%"
          mx="auto"
          ml={{ '2xl': '10%' }}
          alignItems={'center'}
          maxW="1330px"
          maxH="1240px"
        >
          {/* Image Of the Quote */}
          <Flex
            w="100%"
            maxW="1920px"
            fontFamily="var(--FedraSansStd-book-i)"
            fontSize="18px"
            color="#28231E"
            flexDir={{
              lg: 'row',
              base: 'column',
            }}
          >
            <Box
              mx={{ base: 'auto', md: 'auto' }}
              alignItems={{ base: 'center' }}
              pt={{ base: '45px', lg: '13%', '2xl': '7%' }}
              mt={{ base: '20px', md: '0' }}
              pl={{ lg: '150px', '2xl': '0' }}
              maxWidth="none"
            >
              <Box
                width={{
                  lg: '242px',
                  md: '156px',
                  base: '156px',
                  '2xl': '350px',
                }}
                marginLeft={{ '2xl': '6rem' }}
                marginTop={{ base: '3rem', md: '3rem', lg: '0', '2xl': '1rem' }}
                height={{ lg: '166px', '2xl': '241px', base: '107px' }}
                position="relative"
              >
                <LazyLoadImageComponent
                  src={`${config.imgPath}/d/46272/1722335945-quotes-png.png`}
                  alt="no image found"
                  width="100%"
                  layout="fill" // Fills the parent container
                  objectFit="cover" // Ensures the image covers the entire area
                />
              </Box>
            </Box>
            <Flex
              flexDirection="column"
              pl={{ lg: '15px', md: '15px' }}
              pt={{ '2xl': '15%', lg: '18%', md: '5%', base: '10px' }}
              w="100%"
              mx="auto"
              justifyContent={{ base: 'center', lg: 'normal' }}
              alignItems={{ lg: 'normal', base: 'center' }}
            >
              <Text
                maxW={{ md: '718px', sm: '754px', base: '328px' }}
                mx={{ sm: 'auto', md: 'auto' }}
                w={{
                  base: '95%',
                  sm: '70%',
                  md: '90%',
                  lg: '53%',
                  '2xl': '80%',
                }}
                fontFamily="var(--FedraSansStd-book-i)"
                fontSize={{
                  '2xl': '2.25rem',
                  md: '24.94px',
                  base: '1.375rem',
                }}
                fontWeight={'400'}
                color="#010509"
                textAlign={{
                  base: 'center',
                  sm: 'center',
                  md: 'center',
                  lg: 'left',
                }}
                letterSpacing="2%"
                lineHeight={{ '2xl': '57.6px', md: '38.4px', base: '35.2px' }}
                mr={{ lg: '423px' }}
                mt={{ lg: '10px', base: '20px' }}
                fontStyle="italic"
              >
                {quote}
              </Text>
              <Box as="span" fontWeight={'bold'}>
                <Box
                  fontFamily="var(--FedraSansStd-medium)"
                  fontSize={{
                    md: '24.94px',
                    base: '1.375rem',
                    '2xl': '2.25rem',
                  }}
                  fontStyle="italic"
                  // fontWeight={{ md: '600', base: '700' }}
                  fontWeight={400}
                  color="#010509"
                  lineHeight={{ md: '57.6px', base: '35.2px' }}
                  textAlign={{ base: 'center', lg: 'left' }}
                >
                  -Sadhguru
                </Box>
              </Box>
            </Flex>
          </Flex>
        </Flex>

        <Box
          mixBlendMode="multiply"
          objectFit="cover"
          display="flex"
          alignItems="flex-end"
          justifyContent="flex-end"
          position="absolute"
          right="0"
          opacity={0.4}
          bottom={{ lg: '8rem', base: '10%', '2xl': '18%' }}
          // width={{ base: '30%' }}
          width={{ base: '60%', md: '50%', lg: '35%' }}
        >
          <LazyLoadImageComponent
            src={`${config.imgPath}/d/46272/1732013668-handimage.png`}
            alt="no image"
            layout="responsive"
            // width={266}
            // height={557}
            width="100%"
            height="100%"
          />
          {/* Use percentage width for responsiveness */}
        </Box>
      </Box>
    </Box>
  );
};

export default SamskritiQuote;
